import { getEnvConfig } from '@praxis/component-runtime-env'

const config = async () => {
  const envConfig = await getEnvConfig()
  return envConfig
}

export default config
